module.exports = __webpack_public_path__ + "assets/img/0407.464cdd11.png";